import { render, staticRenderFns } from "./ModernaView.vue?vue&type=template&id=585e553a&scoped=true&"
import script from "./ModernaView.vue?vue&type=script&lang=js&"
export * from "./ModernaView.vue?vue&type=script&lang=js&"
import style0 from "./ModernaView.vue?vue&type=style&index=0&id=585e553a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e553a",
  null
  
)

export default component.exports